import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import ExportForm from '@app/components/apps/Export/ExportForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const EditExport: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Pre-Clearance Category');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const expType = localStorage.getItem('exportType');
  const exportPath = expType === 'DRUG' ? '/export/feed-and-drugs' : '/export/normal';

  const routes = [
    {
      path: exportPath,
      breadcrumbName: 'Export',
    },
    {
      path: '/edit-export',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName, expType]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ExportForm
            type="edit"
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'Edit Export'}
            editable={true}
            id={id}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditExport;
